import apiClient, { handleApiError } from "@/api/openApiClient";
import { AssetRequest, AssetResponse } from "@telegraphio/bapi-types";

export interface AssetsApi {
  getAssetHistory(customerId: string, equipmentId: string, request: AssetRequest): Promise<AssetResponse>;
}

export const assetsApi: AssetsApi = {
  async getAssetHistory(customerId: string, equipmentId: string, request: AssetRequest): Promise<AssetResponse> {
    const { data, error, response } = await apiClient.POST("/assets/{customer_id}/{equipment_id}", {
      params: {
        path: {
          customer_id: customerId,
          equipment_id: equipmentId,
        },
      },
      body: { ...request },
    });

    if (error) {
      handleApiError(error, response, "Failed to get asset history");
    }

    return data;
  },
};
